import React from 'react';
import { UploadTypes } from './UploadTypes';
import { DataUpload } from './DataUpload';
import { Wrapper, Content } from './Configure.styles';
import { UPLOAD_TYPES } from './utils';
import DownloadingFile from './DownloadingFile/DownloadingFile';
import SendMail from './SendMail/SendMail';
import TestMail from './TestMail/TestMail';

export class Configure extends React.Component {
	state = {
		type: null,
		baselineUploadType: null,
	};

	changeUploadType = (type, baselineType) => {
		this.setState({
			type,
			baselineUploadType: baselineType,
		});
	};
	render() {
		const { type, baselineUploadType } = this.state;
		const { fetchBudget } = this.props;
		const { location } = this.props;
		return (
			<Wrapper>
				<Content>
					{!type ? (
						<UploadTypes onChange={this.changeUploadType} />
					) : (
						<>
							{type === UPLOAD_TYPES.DOWNLOAD && <DownloadingFile />}
							{type === UPLOAD_TYPES.UPLOAD && (
								<DataUpload
									type={type}
									isAppend={type === UPLOAD_TYPES.APPEND}
									fetchBudget={fetchBudget}
									location={location}
									baselineUploadType={baselineUploadType}
								/>
							)}
							{type === UPLOAD_TYPES.SENDMAIL && (
								<SendMail location={location} />
							)}
							{type === UPLOAD_TYPES.TESTMAIL && (
								<TestMail location={location} />
							)}
						</>
					)}
				</Content>
			</Wrapper>
		);
	}
}
